function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.383 12.098H46.68v19.826c-.334 1.743-2.55 2.116-4.51 2.806-3.85.855-8.317.855-11.62.35-2.596-.34-6.09-1.632-6.167-3.156zM10.31.613H2.782c-.15 0-.274.13-.274.274v7.617H20V3.177c0-.252-.194-.46-.444-.46h-7.13L10.504.722l-.01-.02c-.047-.056-.115-.09-.184-.09z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.512.528H2.76c-.154 0-.283.13-.283.274V8.42h18.016V3.092c0-.253-.2-.46-.457-.46h-7.342L10.71.637 10.7.616c-.047-.055-.118-.088-.188-.088z",
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.79999983,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.915 2.847v5.195h11.3V2.847z",
  className: "icon-secondary",
  fill: "#adb9ca",
  fillRule: "evenodd"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.548 2.635H5.524V10.7h12.024z",
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000001,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.953 4.686l-7.275.032c-.032 0-.075.01-.107.02l-.085.064-.01-.01-2.928 2.89-6.4.032c-.255 0-.47.21-.47.462l-.042 7.8c0 .263.214.463.47.463l9.52-.043 7.093-.032h.182c.16 0 .288-.136.288-.284v-.188l.043-7.8.012-3.132c0-.158-.128-.284-.29-.274z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20.198 4.27l-7.444.034c-.033 0-.077.01-.11.022l-.087.065-.01-.01L9.55 7.394l-6.548.033c-.262 0-.48.22-.48.482l-.045 8.13c0 .275.22.484.48.484l9.742-.044 7.258-.033h.186c.164 0 .295-.143.295-.296v-.196l.043-8.132.01-3.266c0-.165-.13-.296-.295-.285z",
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000001,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M45.997 32.264l-.384.756c-.844.866-2.433 1.206-3.868 1.72-3.76.845-8.132.845-11.366.352-2.543-.35-5.963-1.633-6.04-3.146V30.16z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M49.426 21.327c-1.234 0-2.234.973-2.234 2.173 0 1.21 1 2.183 2.234 2.183 1.245 0 2.245-.973 2.245-2.183 0-1.2-1-2.173-2.244-2.173zM48.476 16h1.95l.55 1.756 1.674.585 1.622-.723 1.337 1.31-.828 1.478.643 1.666 1.755.577v1.805l-1.704.576-.694 1.528.92 1.666-1.48 1.3-1.623-.804-1.623.665L50.375 31h-1.938l-.602-1.657-1.48-.585-1.714.724-1.294-1.26.693-1.706-.562-1.44-1.805-.624v-1.756l1.714-.625.652-1.576-.837-1.657 1.347-1.31 1.714.765 1.612-.625z",
  className: "icon-primary",
  fill: "#ecaec6",
  fillRule: "evenodd"
});
var _ref0 = /*#__PURE__*/React.createElement("path", {
  d: "M49.53 21.254c-1.27 0-2.296 1.027-2.296 2.295 0 1.278 1.027 2.305 2.295 2.305 1.278 0 2.305-1.027 2.305-2.306 0-1.27-1.027-2.296-2.306-2.296zm-.975-5.63h2.002l.566 1.856 1.72.62 1.665-.766 1.373 1.383-.848 1.562.66 1.76 1.804.608v1.908l-1.75.608-.714 1.614.944 1.76-1.52 1.374-1.667-.85-1.667.703-.62 1.71h-1.99l-.62-1.752-1.52-.618-1.76.765-1.33-1.33.712-1.804-.577-1.52-1.855-.66V22.7l1.76-.66.672-1.667-.86-1.75 1.384-1.384 1.76.806 1.656-.66z",
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000001,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});
var _ref1 = /*#__PURE__*/React.createElement("path", {
  d: "M24.34 12.274c0-1.984 4.89-3.595 10.916-3.595 6.04 0 10.916 1.61 10.916 3.594 0 1.994-4.877 3.595-10.916 3.595-6.027 0-10.915-1.602-10.915-3.596z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref10 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000001
}, React.createElement("path", {
  d: "M46.167 32.264c-.996 1.777-2.902 2.008-4.253 2.477-3.76.845-8.132.845-11.365.352-2.543-.35-5.963-1.633-6.04-3.146V30.16",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 6.66666651
}), React.createElement("path", {
  d: "M24.51 12.098v9.634",
  strokeMiterlimit: 6.66666651
}), React.createElement("path", {
  d: "M24.51 12.274c0-1.984 4.936-3.595 11.022-3.595 6.098 0 11.022 1.61 11.022 3.594 0 1.994-4.924 3.595-11.022 3.595-6.086 0-11.022-1.602-11.022-3.596",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M46.554 12.098v2.872",
  strokeMiterlimit: 6.66666651
}));
var _ref11 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000001
}, React.createElement("path", {
  d: "M12.49 19.424c1.918 4.23 7.138 6.602 12.695 6.525",
  strokeMiterlimit: 8
}), React.createElement("path", {
  d: "M20.407 20.51l5.04 5.49-5.906 4.428"
}));
var SvgMenuManagedata = function SvgMenuManagedata(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 60,
    height: 36,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10, _ref11);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuManagedata, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Menu-managedata.331df306.svg";
export { ForwardRef as ReactComponent };